<div class="landing-wrapper flex items-center justify-center min-h-screen w-full" [style.background-image]="bgImage" [ngStyle]="wrapperStyles">
    <div class="backdrop-card" [ngStyle]="backdropStyles">
        <div class="flex flex-col md:flex-row w-full mx-auto px-4 pb-6 justify-between" style="max-width: 1300px;">
            <!-- Columna Izquierda: Título y Descripción -->
            <div class="w-full md:w-7/12 text-white text-center md:text-left mb-2 md:mb-0 p-1 md:p-4 pb-4 md:pb-8 md:pl-7">
                    <div class="w-full text-center md:text-left mb-7 md:mb-8 mt-3">
                        <img class="logo mx-auto md:mx-0" style="width: 15rem; max-width: 100%;"
                            [src]="logoUrl" alt="logo"
                            [ngStyle]="logoStyles" />
                    </div>
                    <h1 class="titulo mb-3 md:mb-5" [ngStyle]="tituloStyles">
                        {{ nom_c ? nom_c : 'Título de la Campaña' }}
                    </h1>
                    <p class="sub-titulo font-light" [ngStyle]="subTituloStyles">
                        {{ desc ? desc : 'Aquí irá la descripción de la campaña. Este texto puede cambiar dinámicamente según los parámetros.' }}
                    </p>

                    @if (desc2) {
                        <p class="sub-titulo-2 font-light" [ngStyle]="subTitulo2Styles">{{ desc2 }}</p>
                    }

                    @if (recursoUrl) {
                        <img [src]="recursoUrl" alt="Imagen de apoyo" class="imagen-apoyo mt-4 mx-auto md:mx-0 rounded-lg" [ngStyle]="recursoImagenStyles" />
                    }
            </div>


            <!-- Columna Derecha: Formulario y Simulador -->
            <div class="w-full md:w-4/12 flex md:items-center justify-center md:justify-end">
                <div class="flex flex-col gap-3 w-full md:pr-3">
                    <p-card styleClass="glass-panel py-5 px-4">
                        <form [formGroup]="formGroup">
                            <p-icon-field styleClass="mb-3">
                                <p-inputicon styleClass="pi pi-user" />
                                <input id="firstname" class="w-full text-default" type="text" autocomplete="given-name" 
                                    onkeypress="return /[A-Z \Ñ]/i.test(event.key)" oninput="this.value = this.value.toUpperCase()"
                                    pInputText formControlName="nombres" placeholder="Nombre(s)*" />
                            </p-icon-field>
                            <div class="flex flex-row gap-2 mb-3">
                                <p-icon-field class="w-1/2">
                                    <p-inputicon styleClass="pi pi-user" />
                                    <input id="lastname" type="text" autocomplete="family-name" onkeypress="return /[A-Z \Ñ]/i.test(event.key)"
                                        class="w-full text-default" oninput="this.value = this.value.toUpperCase()" pInputText
                                        formControlName="ap_pat" placeholder="Ap. Paterno *" />
                                </p-icon-field>
                                <p-icon-field class="w-1/2">
                                    <p-inputicon styleClass="pi pi-user" />
                                    <input id="lastname2" type="text" class="w-full text-default"  autocomplete="off"
                                        onkeypress="return /[A-Z \Ñ]/i.test(event.key)" oninput="this.value = this.value.toUpperCase()"
                                        pInputText formControlName="ap_mat" placeholder="Ap. Materno" />
                                </p-icon-field>
                            </div>
                            <div class="w-full mb-3">
                                <app-intl-tel-input></app-intl-tel-input>
                            </div>
                            <p-icon-field styleClass="mb-4">
                                <p-inputicon styleClass="pi pi-envelope" />
                                <input id="mail" class="w-full text-default" type="email" pInputText formControlName="email"
                                    placeholder="Correo Electrónico" />
                            </p-icon-field>
                            <p-floatLabel variant="on">
                                <p-dropdown inputId="pais" formControlName="pais" [options]="countries" optionLabel="pais"
                                    (onChange)="onSelectCountry($event)" styleClass="w-full mb-4 text-default" [filter]="true"
                                    filterBy="pais" [showClear]="true" placeholder="Seleccione un país">
                                </p-dropdown>
                                <label for="pais">País</label>
                            </p-floatLabel>
                            <p-floatLabel variant="on" [style.display]="cities.length > 0 ? 'block' : 'none'">
                                <p-dropdown inputId="ciudad" formControlName="ciudad" [options]="cities" optionLabel="estado"
                                    (onChange)="onSelectCity($event)" styleClass="w-full mb-3 text-default" [filter]="true"
                                    filterBy="estado" [showClear]="true" placeholder="Seleccione una ciudad">
                                </p-dropdown>
                                <label for="ciudad">Ciudad</label>
                            </p-floatLabel>
                            <p-button styleClass="btn-send w-full mt-2" icon="pi pi-whatsapp" [label]="labelBoton" (click)="onClickSend()"
                                [disabled]="!formGroup.valid || validar()" [style]="{'background-color': buttonColor, 'border-color': buttonColor}"></p-button>
                        </form>
                        <p class="nota">*Rellena la información para que te asignemos el asesor indicado para el chat de WhatsApp</p>
                    </p-card>
                </div>
            </div>
        </div>
    </div>
</div>